import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { CustomFilterProps, Filter, Option, ViewValue } from './filter';

const VIEW_FILTER_OPTIONS: Option[] = [
  {
    label: <FormattedMessage id="all_tasks" />,
    value: ViewValue.All,
  },
  {
    label: <FormattedMessage id="incomplete_tasks" />,
    value: ViewValue.Incomplete,
  },
  {
    label: <FormattedMessage id="completed_tasks" />,
    value: ViewValue.Completed,
    subMenuLabel: <FormattedMessage id="since" />,
    options: [
      {
        label: <FormattedMessage id="today" />,
        value: ViewValue.Today,
      },
      {
        label: <FormattedMessage id="yesterday" />,
        value: ViewValue.Yesterday,
      },
      {
        label: <FormattedMessage id="weeks.count" values={{ count: 1 }} />,
        value: ViewValue.LastOneWeek,
      },
      {
        label: <FormattedMessage id="weeks.count" values={{ count: 2 }} />,
        value: ViewValue.LastTwoWeeks,
      },
    ],
  },
];

export const ViewFilter: FC<CustomFilterProps> = ({ onChange }) => (
  <Filter
    label={<FormattedMessage id="view" />}
    options={VIEW_FILTER_OPTIONS}
    value={ViewValue.Incomplete}
    onChange={onChange}
  />
);
